import { useEffect, useRef } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useToolQueue } from "../../../contexts/ToolQueueContext";
import './LoadingTool.scss';

export default function LoadingTool() {
    const { loadingTools } = useToolQueue();


    return (
        <div className="loadingConsole">
            {
                loadingTools.includes("formulas") && (
                    <div className="loadingContainer">
                        <AiOutlineLoading3Quarters className="loadingAnimate" />
                        <p>Loading Formula . Please Wait for a moment</p>
                    </div>
                )
            }
            {
                loadingTools.includes("visualization") && (
                    <div className="loadingContainer">
                        <AiOutlineLoading3Quarters className="loadingAnimate" />
                        <p>Loading Visualization</p>
                    </div>
                )
            }
            {
                loadingTools.includes("graph") && (
                    <div className="loadingContainer">
                        <AiOutlineLoading3Quarters className="loadingAnimate" />
                        <p>Loading Graph</p>
                    </div>
                )
            }
            {
                loadingTools.includes("calculate") && (
                    <div className="loadingContainer">
                        <AiOutlineLoading3Quarters className="loadingAnimate" />
                        <p>Calculating details. Please Wait</p>
                    </div>
                )
            }
            {
                loadingTools.includes("showcase") && (
                    <div className="loadingContainer">
                        <AiOutlineLoading3Quarters className="loadingAnimate" />
                        <p>Gathering the details to show. Please Wait</p>
                    </div>
                )
            }
        </div>
    )
}